import React from 'react';
import Lottie from 'react-lottie';

function LottieAnimation(props) {
    const { loop, animateFile, height, width } = props;
    const defaultOptions = {
        loop: loop,
        autoplay: true,
        animationData: animateFile,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice',
        },
    };
    return (
        <Lottie
            options={defaultOptions}
            height={height || 150}
            width={width || 150}
            isStopped={false}
            isPaused={false}
        />
    );
}

export default LottieAnimation;